<template>
  <div class="container section">
    <div class="row heading">
      <div class="col">
        <h2>Files</h2>
      </div>
    </div>
    <div class="row table-head" >
      <div class="col">File Details</div>
      <div class="col">Date Added</div>
      <div class="col">Uploaded By</div>
      <div class="col">&nbsp</div>
    </div>
    <div class="row lined" v-for="f, i in leadFiles" :key="f.leadFile_id">
      <div class="col">{{f.file_name}}</div>
      <div class="col">{{f.timestamp | formatDate}} </div>
      <div class="col">{{f.user_name}}</div>
      <div class="col text-right">
        <a :href="f.leadFile_url + $store.getters.getToken" class="btn btn-sm btn-download"><i class="fa fa-download"></i> Download</a>
        <dropdown-confirmation
          @confirm="deleteFile(f)">
        </dropdown-confirmation>
      </div>
    </div>

    <div class="row lined" v-if="!uploading && (!leadFiles || !leadFiles.length)">
      <div class="col">There are no files on this lead.</div>
    </div>

    <div class="upload-form">
      <vue-clip :options="options" class="" :on-added-file="fileAdded" :on-sending="sending" :on-complete="complete">
        <template slot="clip-uploader-body" scope="props">
          <div class="row lined upload-preview" v-for="file, i in props.files" v-show="file.progress < 100 && file.status != 'success'">
            <div class="col">

              <div class="media">
                <!--
                <img v-if="file.dataUrl" class="d-flex mr-3" width="60" :src="file.dataUrl" >
                <div v-else class="d-flex justify-content-center align-items-center mr-3 img-placeholder" >
                  <i class="fa fa-file-text"></i>
                </div>
                -->
                <div class="media-body">
                  <a @click="props.files.splice(i, 1)" class="link-padding float-right" v-if="file.status == 'error'"><i class="fa fa-remove text-danger"></i></a>
                  <h5 class="mt-2">
                    {{file.name}}
                    <div v-show="file.progress == 100 && file.status != 'added'" class="file-status" :class="{'text-danger': isError(file.status), 'text-success': isSuccess(file.status) }">{{file.status}}</div></h5>
                  <div class="file-progress" v-show="file.progress < 100 ">
                    <span class="progress-indicator" :class="{error: isError(file.status) }" v-bind:style="{width:file.progress + '%'}"></span>
                  </div>
                  <div class="text-danger link-padding" v-show="file.errorMessage">{{file.errorMessage}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template class="upload-btn" slot="clip-uploader-action" scope="props">
          <button class="btn btn-primary dz-message" href="#"><i class="fa fa-plus"></i> &nbsp;Add File(s)</button>
        </template>
      </vue-clip>
    </div>
  </div>
</template>
<script type="text/babel">
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import Dropdown from '../assets/Dropdown.vue';

  export default {
    name: 'LeadFiles',
    data: function(){
      return {
        params: {
          data: {
            lead_id: ''
          }
        },
        options:{
          url: '',
          headers: {

          }
        },
        leadFiles:[],
        files:[],
        uploading: false,

      }
    },
    components:{
      Dropdown,
      DropdownConfirmation
    },
    created(){

      this.options.url = this.$endpoint;
      this.params.data.lead_id = this.$route.params.lead_id;
      this.fetchLeadFiles();
    },
    computed:{

    },
    filters:{
      formatDate(date){
          return moment(date).format('MM/DD/YYYY HH:mm:ss')
      }
    },
    methods:{
      fileNotYetLoaded(file){
        return file.progress < 100 && file.status != 'success';
      },
      complete(file){
        this.fetchLeadFiles();
      },
      isError(status){
        return status == "error";
      },
      isSuccess(status){
        return status == "success";
      },
      fileAdded(){
        this.uploading = true;
      },
      sending (file, xhr, formData) {
          formData.append('function', 'leadFileCreate');
          formData.append("token", this.$store.getters.getToken);
          formData.append("data[lead_id]", this.params.data.lead_id);
      },
      fetchLeadFiles(){
        var _this = this;


        this.$send(this, 'leadFiles',  {
          lead_id: this.$route.params.lead_id
        }).then(r => {
          this.leadFiles = r.leadFiles;
        });
      },

      deleteFile(f){
        this.$send(this, 'leadFileDelete', f).then(r => {
            this.fetchLeadFiles();
        });

      }
    },
    props:{
      details: {
        type: Object
      }
    }

  }

</script>
<style scoped>
  .file-status{
    text-transform: uppercase;
    padding: 5px 0;
  }
  .img-placeholder{
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background-color: #f0f0f0;
  }
  .img-placeholder i{
    color: #ccc;
  }
  .file-progress{
    height: 2px;
    border-radius: 2px;
    overflow: hidden;
    margin: 6px 0;
    width: 100%;
    background-color: #e2e2e2;
    position:relative;

  }
  .progress-indicator{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    background-color: #5e9cd3;
  }

  .progress-indicator.error{
      background-color: #d9534f;
  }
  .progress-indicator.success{
    background-color: #d9534f;
  }
  .link-padding{
    padding: 5px 10px;
  }
  h5{
    margin: 0 px;
    font-size: 12px;
  }
  .media img{
    border: none;
  }
  .dz-message{
    margin: 15px 0px;
  }
  .dz-message{
    position:absolute;
    bottom: 0px;
    left: 0px;
  }
  .upload-form {
    padding-bottom: 65px;
    position:relative;
  }


</style>



// WEBPACK FOOTER //
// LeadFiles.vue?5f25d4ee